import { render } from "./customer_profile.html?vue&type=template&id=807c5bd0&scoped=true&external"
import script from "./customer_profile.js?vue&type=script&lang=js&external"
export * from "./customer_profile.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=807c5bd0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807c5bd0"]])

export default __exports__